const domains = [
  'Dashboard',
  'CreateAccountPlan',
  'Global'
]

export default domains
